import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "hollow", "variant"];
import styled from 'styled-components';
import { filterProps } from '../../utils';
import { getVariantTokens } from './StatusDot.helpers';
import { useVariantCssObject } from './StatusDot.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledStatusDot = styled.span.withConfig({
  displayName: "StatusDot__StyledStatusDot",
  componentId: "sc-1xo0d1z-0"
})(({
  $variantCssStyles
}) => {
  return Object.assign({}, $variantCssStyles);
});
export function StatusDot(_ref) {
  let {
      'aria-label': ariaLabel,
      hollow = false,
      variant = 'neutral'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps
  } = filterProps(props, {
    labelable: true
  });
  const variantTokens = getVariantTokens(variant);
  const variantCssStyles = useVariantCssObject(variantTokens, hollow);
  return /*#__PURE__*/_jsx(StyledStatusDot, Object.assign({}, domProps, {
    $hollow: hollow,
    "aria-hidden": ariaLabel ? undefined : true,
    "aria-label": ariaLabel,
    $variantCssStyles: variantCssStyles
  }));
}